<template>
  <DropdownItemView v-once aria-role="listitem" has-link v-if="authUser.permission.canLogIssue">
    <a :href="logIssueUrl" target="_blank">
      <DropdownItemContent :label="$t('core.log-issue-clickup')">
        <template #icon>
          <img src="@/assets/logos/clickup-logo.png" alt="clickup-logo" />
        </template>
      </DropdownItemContent>
    </a>
  </DropdownItemView>
</template>

<script>
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import { ClickUpUrl } from '@/modules/core/nav/constants/ClickUpUrl';
import DropdownItemContent from '@/modules/core/app/components/DropdownItemContent.vue';
import DropdownItemView from '@/modules/core/ui/components/wrappers/DropdownItemView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LogIssueDropdownItem',
  mixins: [HasAuthUserMixin],
  components: { DropdownItemContent, DropdownItemView },
  computed: {
    logIssueUrl() {
      return this.authUser.canLogClearDeskIssue
        ? ClickUpUrl.CLEARDESK_LOG_ISSUE
        : ClickUpUrl.STANDARD_LOG_ISSUE;
    }
  }
};
</script>

<style scoped>
img {
  width: var(--ce-6px);
  height: var(--ce-6px);
}
</style>
